import { render, staticRenderFns } from "./teamsAdd.vue?vue&type=template&id=16793faf&"
import script from "./teamsAdd.vue?vue&type=script&lang=js&"
export * from "./teamsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports